module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAAASUlEQVQ4y93TwQ0AIAgDwOKwDMWydQJsI/Fj/70ACUESkywM8w6oKo4ncBC5gkKsG5wQ+4gdYgOZGddAV7aAU1kCqgwA8fEvuNnc+hjm3Tu0lQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/dataGrid/icon_right_kong.png
// module id = 2027
// module chunks = 50